import {isEmpty, map} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {InformationModal} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {ApiError} from 'types';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.INVALID_FILE_TYPE_MODAL;

type Props = {
    open: boolean;
    error?: ApiError;
    onClose: () => void;
}

export const InvalidFileTypeModal: React.FC<Props> = ({open, error, onClose}: Props) => {
    const {t} = useTranslation();

    const supportedExtensions: string[] = useMemo(() => {
        const expectedExtensions = error?.response?.data?.errors?.extension?.expected;
        return !isEmpty(expectedExtensions) ? map(expectedExtensions, (ext) => `.${ext}`) : [];
    }, [error]);

    return (
        <InformationModal open={open} title={t(T_KEYS.TITLE)} onClose={onClose}>
            <div>{t(T_KEYS.MESSAGE)}</div>
            {!isEmpty(supportedExtensions) &&
                <div className='tw-mt-6'>
                    <div className='tw-font-bold tw-mb-2'>{t(T_KEYS.EXTENSIONS_TITLE)}</div>
                    <div className='tw-grid tw-grid-cols-4 tw-gap-2'>
                        {map(supportedExtensions, (extension: string) => <div key={extension}>{extension}</div>)}
                    </div>
                </div>}
        </InformationModal>
    );
};